import RightPopupComponent from "components/RightPopup";

import InputPhone from "components/InputPhone";

import '../index.less';
import '../themes/default.less';

export default class PersonDelegateDate extends RightPopupComponent {

    insertInputs(props, props2, props3) {
        return (
            <div className="inputs flex gap16">
                {this.insertInput(props)}
                {this.insertInput(props2)}
                {props3 && this.insertInput(props3)}
            </div>
        );
    }

    render() {
        const { data, onChangePersonDelegateDate, isPersonDelegateDate } = this.props;
        const active = isPersonDelegateDate ? "active" : "";
        const info = (data || {});
        const { lastName, firstName, middleName, phoneNumber,
            relative, seriesPSP, numberPSP, issueDatePSP, depCodePSP,
            birthPlace, citizenship, address, snils, issuedBy } = info;
        let isDate = issueDatePSP;
        if (issueDatePSP && issueDatePSP.includes("-")) {
            const arr = issueDatePSP.split("-");
            if (arr?.length === 3)
                isDate = `${arr[2]}.${arr[1]}.${arr[0]}`;
        }

        return (
            <div className={`passport flex col gap16 ${active}`}>

                <div className="inputs flex gap4">
                    {this.insertInput({
                        value: lastName,
                        itemStyle: "flex1",
                        label: "main.lname",
                        placeHolder: "main.lnamePlace",
                        validator: this._helper.inputValidators.capitalize,
                        onChange: onChangePersonDelegateDate.bind(this, "lastName")
                    })}
                    {this.insertInput({
                        value: firstName,
                        itemStyle: "flex1",
                        label: "main.fname",
                        placeHolder: "main.fnamePlace",
                        validator: this._helper.inputValidators.capitalize,
                        onChange: onChangePersonDelegateDate.bind(this, "firstName"),
                    })}
                    {this.insertInput({
                        value: middleName,
                        itemStyle: "flex1",
                        label: "main.sname",
                        placeHolder: "main.snamePlace",
                        validator: this._helper.inputValidators.capitalize,
                        onChange: onChangePersonDelegateDate.bind(this, "middleName"),
                    })}
                </div>
                <div className="flex flex1 gap16">
                    {this.insertInput({
                        value: relative,
                        itemStyle: "flex1",
                        label: "Кем приходится",
                        placeHolder: "Брат, сестра...",
                        validator: this._helper.inputValidators.capitalize,
                        onChange: onChangePersonDelegateDate.bind(this, "relative"),
                    })}
                    <InputPhone
                        value={phoneNumber}
                        itemStyle="flex1"
                        label="main.telephone"
                        onChange={onChangePersonDelegateDate.bind(this, "phoneNumber")}
                    />
                </div>
                <div className="flex1 flex gap8">
                    <div className="flex gap1" style={{ flex: 2 }}>
                        {this.insertInput({
                            value: seriesPSP,
                            itemStyle: "flex1",
                            label: "client.series",
                            placeHolder: "0000",
                            onChange: onChangePersonDelegateDate.bind(this, "seriesPSP")
                        })}
                        {this.insertInput({
                            value: numberPSP,
                            itemStyle: "flex1",
                            label: "client.number",
                            placeHolder: "000000",
                            onChange: onChangePersonDelegateDate.bind(this, "numberPSP")
                        })}
                    </div>
                    <div style={{ flex: 1 }}>
                        {this.insertInput({
                            value: isDate,
                            itemStyle: "flex1",
                            label: "client.whenIssued",
                            placeHolder: "01.01.2000",
                            validator: this._helper.inputValidators.date,
                            onChange: onChangePersonDelegateDate.bind(this, "issueDatePSP")
                        })}
                    </div>
                </div>
                <div className="flex1 flex gap8">
                    <div className="flex gap1" style={{ flex: 2 }}>
                        {this.insertInput({
                            value: issuedBy,
                            itemStyle: "flex1",
                            label: "client.issuedBy",
                            placeHolder: "client.nameIssued",
                            validator: this._helper.inputValidators.capitalize,
                            onChange: onChangePersonDelegateDate.bind(this, "issuedBy")
                        })}
                    </div>
                    <div style={{ flex: 1 }}>
                        {this.insertInput({
                            value: depCodePSP,
                            label: "client.departmentCode",
                            placeHolder: "000-000",
                            format: "xxx-xxx",
                            validator: this._helper.inputValidators.format,
                            onChange: onChangePersonDelegateDate.bind(this, "depCodePSP")
                        })}
                    </div>
                </div>
                {this.insertInputs({
                    value: birthPlace,
                    label: "client.placeBirth",
                    placeHolder: "client.placeBirth",
                    validator: this._helper.inputValidators.capitalize,
                    onChange: onChangePersonDelegateDate.bind(this, "birthPlace")
                }, {
                    value: citizenship,
                    label: "client.citizenship",
                    validator: this._helper.inputValidators.capitalize,
                    placeHolder: "client.citizenship",
                    onChange: onChangePersonDelegateDate.bind(this, "citizenship")
                })}
                <div className="flex gap8">
                    {this.insertInput({
                        itemStyle: "flex1",
                        value: snils,
                        label: "СНИЛC",
                        placeHolder: "000-000-000-00",
                        format: "xxx-xxx-xxx-xx",
                        validator: this._helper.inputValidators.format,
                        onChange: onChangePersonDelegateDate.bind(this, "snils")
                    })}
                    <div className="flex1"></div>
                </div>
                <div className="inputFull">
                    {this.insertInput({
                        value: address,
                        itemStyle: "flex1",
                        label: "client.registrAddress",
                        placeHolder: "client.exampleAddress",
                        onChange: onChangePersonDelegateDate.bind(this, "address")
                    })}
                </div>
            </div>
        );
    }
}

